<kPopupWidget #captionRequest data-aid="captionRequest" [fullScreen]="true">
  <ng-template>
    <kReach [parentPopup]="captionRequest" [page]="_page" [data]="_data"></kReach>
  </ng-template>
</kPopupWidget>
